const ObjectsTypes = {
    ADD_OBJECTS: "themet/addObjects", // to fetch a single object from the met api and add it to the list
    DROP_OBJECT: "themet/dropObject", // to drop an object from lists (search and all objects)
    CLEAN_OBJECTS: "themet/cleanObjects",
}

export default ObjectsTypes;